import React from 'react';
import { inputBaseClass } from '../../utils/formatters';

/**
 * Standardized form field component with consistent styling
 * Supports input, textarea, and select field types
 */

const FormField = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  error,
  required = false,
  placeholder,
  disabled = false,
  as = 'input', // 'input' | 'textarea' | 'select'
  options = [], // for select: [{ value, label }]
  rows = 3, // for textarea
  className = '',
  min,
  max,
  step,
}) => {
  const getComponent = () => {
    const baseProps = {
      id: name,
      name,
      value: value ?? '',
      onChange,
      placeholder,
      disabled,
      className: `${inputBaseClass} ${error ? 'border-red-500' : ''} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`,
    };

    if (as === 'textarea') {
      return (
        <textarea
          {...baseProps}
          rows={rows}
        />
      );
    }

    if (as === 'select') {
      return (
        <select {...baseProps}>
          {options.map(opt => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      );
    }

    // Default: input
    return (
      <input
        {...baseProps}
        type={type}
        min={min}
        max={max}
        step={step}
      />
    );
  };

  return (
    <div className={`space-y-1 ${className}`}>
      {label && (
        <label
          htmlFor={name}
          className="block text-sm font-medium text-slate-700 dark:text-[#a3bfdb]"
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      {getComponent()}

      {error && (
        <p className="text-red-500 text-xs mt-1">{error}</p>
      )}
    </div>
  );
};

export default FormField;
